import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { SoundOutlined, CloseOutlined, RightOutlined } from '@ant-design/icons';
import './index.css';

// ══════════════════════════════════════════════
//  GlobalCaption — 全局浮窗字幕（流光边框）
//  类似全局通知：顶部居中悬浮，支持轮播、暂停、关闭
// ══════════════════════════════════════════════

// TODO: 联调时替换为接口数据（公告 / 待办 / 版本更新均可复用此结构）
// 浮窗字幕：类型固定为「版本更新」，多条自动轮播；
// path 为「查看」的跳转地址（更新日志）
const MOCK_CAPTIONS = [
    {
        key: 'v1',
        type: '版本更新',
        tone: 'success',
        text: 'v1.2.0 已发布：新增卡券核销记录导出、设备流量账单批量下载。',
        path: '/announcement',
    },
    {
        key: 'v2',
        type: '版本更新',
        tone: 'success',
        text: 'v1.1.8 已发布：生产工单支持批量创建，License 查询速度大幅提升。',
        path: '/announcement',
    },
    {
        key: 'v3',
        type: '版本更新',
        tone: 'success',
        text: 'v1.1.5 已发布：固件 OTA 升级新增失败原因统计，运维排查更高效。',
        path: '/announcement',
    },
    {
        key: 'v4',
        type: '版本更新',
        tone: 'success',
        text: 'v1.1.2 已发布：企业首页看板重构，支持设备盈亏与广告收益多维分析。',
        path: '/announcement',
    },
];

const ROTATE_INTERVAL = 5000; // 轮播间隔（ms）

const GlobalCaption = ({ captions = MOCK_CAPTIONS, onAction }) => {
    const navigate = useNavigate();
    const [index, setIndex] = useState(0);
    const [visible, setVisible] = useState(true);
    const [paused, setPaused] = useState(false);
    const count = captions.length;

    // 自动轮播；鼠标悬浮暂停
    useEffect(() => {
        if (!visible || paused || count <= 1) return undefined;
        const timer = setInterval(() => {
            setIndex((i) => (i + 1) % count);
        }, ROTATE_INTERVAL);
        return () => clearInterval(timer);
    }, [visible, paused, count]);

    const handleClose = useCallback(() => setVisible(false), []);

    // 点击「查看」：优先走外部回调，否则跳转到该条通知的 path（默认更新日志）
    const handleAction = useCallback(() => {
        const item = captions[index];
        if (onAction) {
            onAction(item);
            return;
        }
        navigate(item?.path || '/announcement');
    }, [captions, index, onAction, navigate]);

    if (!visible || count === 0) return null;

    const current = captions[index];

    return (
        <div
            className="gc-root"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
        >
            <div className="gc-beam">
                <div className="gc-inner">
                    <span className={`gc-icon gc-tone-${current.tone}`}>
                        <SoundOutlined />
                    </span>
                    <span className={`gc-tag gc-tone-${current.tone}`}>{current.type}</span>
                    <div className="gc-viewport">
                        <div className="gc-text" key={current.key}>
                            {current.text}
                        </div>
                    </div>
                    <span className="gc-action" onClick={handleAction}>
                        查看 <RightOutlined />
                    </span>
                    <button
                        type="button"
                        className="gc-close"
                        onClick={handleClose}
                        aria-label="关闭字幕"
                    >
                        <CloseOutlined />
                    </button>
                </div>
            </div>

            {count > 1 && (
                <div className="gc-dots">
                    {captions.map((item, i) => (
                        <span
                            key={item.key}
                            className={`gc-dot${i === index ? ' active' : ''}`}
                            onClick={() => setIndex(i)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default GlobalCaption;
